import {
  Alignment,
  ConversationBubble,
  Direction,
  Displaying,
  Spacing,
  Typography,
} from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import { CHATBOT_NAME } from "../../../../../features/ai-chatbot/constants/chatbot-name.const";
import { EmptyComponent } from "../../../common/EmptyComponent";
import type { IChatbotMessage } from "../../entities/chatbot-message.entity";
import { SenderTypeEnum } from "../../enums/sender-type.enum";
import { AiChatbotIconContainer } from "../ai-chatbot-icon-container/ai-chatbot-icon-container";
import { AiChatbotIcon } from "../ai-chatbot-icon/ai-chatbot-icon";
import ChatbotWarningMessage from "../chatbot-warning-message/chatbot-warning-message";
import AiResponseMarkdownMessageParser from "./ai-response-markdown-message-parser/ai-response-markdown-message-parser";

const AiMessageContainer = styled("div")({
  display: Displaying.flex,
  flexDirection: Direction.column,
  gap: Spacing["1000"],
  alignSelf: Alignment.flexStart,
  maxWidth: "100%",
  wordBreak: "break-word",
});

const UserMessageContainer = styled(ConversationBubble)({
  alignSelf: Alignment.flexEnd,
});

interface ChatbotMessageItemProps {
  message: IChatbotMessage;
  animateAiMessage?: boolean;
  showDisclaimer?: boolean;
}

export function ChatbotMessageItem({
  message,
  animateAiMessage = false,
  showDisclaimer = false,
}: Readonly<ChatbotMessageItemProps>) {
  const isUserMessage = message.senderType === SenderTypeEnum.USER;

  if (isUserMessage) {
    return <UserMessageContainer text={message.text} fullWidth={false} maxWidth="100%" />;
  }

  return (
    <AiMessageContainer>
      <AiChatbotIconContainer>
        <AiChatbotIcon animated={false} />
      </AiChatbotIconContainer>
      <Typography variant="body1" color="textPrimary" component="div">
        <AiResponseMarkdownMessageParser markdownString={message.text} animate={animateAiMessage} />
      </Typography>
      {showDisclaimer ? <ChatbotWarningMessage chatbotName={CHATBOT_NAME} alignment="start" /> : <EmptyComponent />}
    </AiMessageContainer>
  );
}
